import { BoundingBox, CategorizedData, DisaggregatedMetric, GeoDetails, GeoTag, Metric, MetricMetadata } from "../services/types";

import healthyFoodSvg from '../assets/healthy-food.svg';
import populationSvg from '../assets/pop-blue.svg';
import disabledSvg from '../assets/individuals-with-disabilities.svg';
import globeSvg from '../assets/foreign-globe.svg';
import limitedEnglishSvg from '../assets/limitedenglish-blue.svg';
import internetSvg from '../assets/internet.svg';
import vehicleSvg from '../assets/vehicle.svg';
import busSvg from '../assets/bus-icon 1.svg';
import roadConditionsSvg from '../assets/road-conditions.svg';
import retailSvg from '../assets/retail-jobs.svg';
import voterSvg from '../assets/voter-participation.svg';
import libraryAccessSvg from '../assets/library-access.svg';
import trailsSvg from '../assets/trails.svg';
import parksQualitySvg from '../assets/qualityparks.svg';

import houseSvg from '../assets/housing-cost-burden.svg';
import costBurdenSvg from '../assets/cost-burdened.svg';
import selfRatedSvg from '../assets/self-rated-health.svg';
import healthInsuranceSvg from '../assets/health-insurance-icon 1.svg';
import fatalSvg from '../assets/fatal-crash.svg';
import lifeExpectancySvg from '../assets/life-expectancy.svg';
import walkabilityindexSvg from '../assets/walkabilityindex.svg';

import educationAttainSvg from '../assets/educationattainment.svg';
import hsgradSvg from '../assets/highschool-grad.svg';
import studentTestSvg from '../assets/studenttest.svg';
import studentMobilitySvg from '../assets/student-mobility.svg';
import kindergartenSvg from '../assets/kindergarten.svg';

import qualityjobsSvg from '../assets/qualityjobs.svg';
import unemploymentSvg from '../assets/unemployment.svg';
import hhincomeSvg from '../assets/medhhincome.svg';
import homeOwnershipSvg from '../assets/homeownership.svg';
import nonautoSvg from '../assets/nonautojobs.svg';
import povSvg from '../assets/povertyrate.svg';

import trafficSvg from '../assets/traffic.svg';
import treesSvg from '../assets/trees.svg';
import dieselSvg from '../assets/diesel.svg';
import pmSvg from '../assets/PM2.5.svg';
import toxicReleaseSvg from '../assets/toxicrelease.svg';
import ozoneSvg from '../assets/ozone.svg';

import houseCostBurden from '../assets/housing-cost-burden.svg';
import descentSvg from '../assets/descent-group.svg';
import lifeSvg from '../assets/low-life.svg';
import transitCommuteSvg from '../assets/transit-commute.svg';
import povertySvg from '../assets/poverty-rate.svg';
import povertyRateSvg from '../assets/200-poverty-rate.svg';
import incomeSvg from '../assets/income.svg';
import jobsSvg from '../assets/jobs.svg';
import pedestrianSvg from '../assets/pedestrian.svg';
import autoToJobsSvg from '../assets/auto-to-jobs.svg';
import transitToJobsSvg from '../assets/transit-to-jobs.svg';
import walkabilitySvg from '../assets/walkabilityindex.svg';
import toxicSvg from '../assets/toxic.svg';
import asthmaSvg from '../assets/asthma.svg';
import treeCanopySvg from '../assets/urban-tree-canopy.svg';
import heatTempSvg from '../assets/heat-and-temp.svg';
import noisePollutionSvg from '../assets/noise-pollution.svg';
import floodRiskSvg from '../assets/flood-risk.svg';


// #region Organization Metric Mapping
export const organizationMetrics: { [orgId: number]: any[] } =
{ 
    // Port of Seattle
    9:
    [
        {
            name: "Demographics",
            ids: [346, 348, 349, 352, 354, 355, 1180],
            order: [
                [352, 348],
                [346, 349]
            ],
            charts: [
                {
                    name: "raceethnicity",
                    id: 354
                },
                {
                    name: "homelanguage",
                    id: 355
                },
                {
                    name: "immigration",
                    id: 1180
                }
            ]
        },
        {
            name: "Livability",
            ids: [318, 334, 335, 336, 338, 339, 340, 341, 342, 343, 1120],
            order: [
                [336, 339, 334, 341],
                [1120, 335], 
                [318, 340],
                [338, 342]
            ],
            charts: [
                {
                    name: "crimerisk",
                    id: 343
                },
            ]
        },
        {
            name: "Accessibility",
            ids: [315, 316, 317, 319, 320, 321, 344, 1153, 1154, 1155],
            order: [
                [320, 344, 315, 321, 1154, 1155, 1153],
                [317, 319, 316]
            ],
            charts: []
        },
        {
            name: "Economy",
            ids: [322, 323, 324, 325, 326, 327, 328, 1156],
            order: [
                [324, 322, 327, 1156],
            ],
            charts: [
                {
                    name: "ged",
                    id: 325
                },
                {
                    name: "bachelors",
                    id: 323
                },
                {
                    name: "masters",
                    id: 326
                },
                {
                    name: "estimatedjobs",
                    id: 328
                },
            ]
        },
        {
            name: "Environment",
            ids: [329, 330, 331, 333, 1121, 1122, 1174, 1175, 1176],
            order: [
                [331, 330, 329, 333, 1121, 1122, 1174, 1175, 1176],
            ],
            charts: []
        }
    ],

    // Lacey
    52:
    [
        {
            name: "Demographics",
            ids: [1130, 1131, 1132, 1133, 1134, 1135, 1147, 1148, 1173, 1182, 1184],
            order: [
                [1133, 1184, 1131],
                [1130, 1132],
            ],
            charts: [
                {
                    name: "race",
                    id: 1134
                },
                {
                    name: "immigration",
                    id: 1182
                }
            ]
        },
        {
            name: "Accessibility",
            ids: [1124, 1137, 1149, 1157, 1158, 1160, 1165, 1166, 1168, 1178, 1179],
            order: [
                [1157, 1124, 1137, 1178, 1166, 1158, 1165, 1149, 1160, 1179],
            ],
            charts: []
        },
        {
            name: "Livability",
            ids: [1128, 1129, 1146, 1150, 1151, 1159, 1172, 1181, 1183],
            order: [
                [1129, 1181, 1159, 1128, 1150, 1146, 1151],
            ],
            charts: [
                {
                    name: "crime",
                    id: 1183
                },
            ]
        },
        {
            name: "Education",
            ids: [1127, 1161, 1162, 1163, 1164, 1170],
            order: [
                [1127, 1163, 1162, 1161],
                [1164] 
            ],
            charts: []
        },
        {
            name: "Economy",
            ids: [1125, 1126, 1138, 1139, 1140, 1167, 1169],
            order: [
                [1167, 1140, 1126, 1125, 1138, 1139],
            ],
            charts: []
        },
        {
            name: "Environment",
            ids: [1141, 1142, 1143, 1144, 1145, 1152, 1171],
            order: [
                [1141, 1152, 1142, 1144, 1145, 1143],
            ],
            charts: []
        }
    ],
    
};

export const organizationNameMap: { [key: number] : string } = {
    9: "Port of Seattle",
    52: "City of Lacey",
    10: "City of Memphis",
    12: "Thurston County",
    5001: "Clark County"
};

// Mapping orgId to their default tabs (categories)
export const orgTabMap: { [key: number]: string } = {
    52: "Demographics", 
    9: "Environment", 
    10: "123",
    5001: "2019_emp_lands",
    5000: "55555",
};

// precisionMapping - maps metricId's to the desired number of significant figures for formatting metric values
export const precisionMapping: { [metricId: number]: number } = {
    // 1125: 1,
    // 1139: 0
    1122: 0,
    330: 0,
};


const svgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Port of Seattle
    9: {
        318: busSvg, // Transit Access
        335: hsgradSvg, // HS Grad Rate
        336: homeOwnershipSvg, // Home Ownership Rate
        1120: lifeSvg, // Low Life Expectancy Rate
        340: transitCommuteSvg, // Transit Commuters
        346: globeSvg,  // Foreign Born
        352: populationSvg, // Total Population
        349: limitedEnglishSvg, // Limited English
        348: disabledSvg, // Individuals with Disabilities
        354: descentSvg,
        339: houseCostBurden,
        // 336: houseOutlineSvg, 
        // 340: bicycleSvg,
        341: houseCostBurden,
        320: pedestrianSvg, // Pedestrian and Bike Facilities
        344: internetSvg, // Households with Internet
        315: voterSvg, // Four Year Average Voter Participation Rate
        321: healthyFoodSvg, // Healthy Food Availability
        1153: walkabilitySvg, // Walkability Index
        1154: transitToJobsSvg, // Transit to Jobs Index
        1155: autoToJobsSvg, // Auto to Jobs Index
        322: unemploymentSvg, // Unemployment Rate
        324: povertySvg, // Poverty Rate 
        327: incomeSvg, // Median HH Income
        328: jobsSvg, // Estimated Jobs Total
        1156: povertyRateSvg, // 200% Poverty Rate
        329: pmSvg, // PM2.5 Particulates
        330: toxicSvg, // Toxic Releases from Facilities
        331: dieselSvg, // Diesel Emissions
        333: trafficSvg, // Proximity to Heavy Traffic Roadways
        1121: asthmaSvg, // Asthma Rates
        1122: treeCanopySvg, // Urban Tree Canopy
        1174: noisePollutionSvg, // Noise Pollution
        1175: floodRiskSvg, // Flood Risk
        1176: heatTempSvg, // Heat and Temperature
    },

    // Lacey
    52: {
        1133: populationSvg,  // Population
        1184: populationSvg, // Population (city lod)
        1131: disabledSvg, // Individuals with Disabilities
        1130: globeSvg, // Foreign Born Population
        1132: limitedEnglishSvg, // Limited English
        1124: internetSvg, // Internet Access
        1137: vehicleSvg, // Access to Household Vehicle
        1178: roadConditionsSvg, // Average Road Quality
        1179: parksQualitySvg, // Parks Access
        1157: busSvg, // Transit Accessibility
        1166: retailSvg, // Retail Service Jobs
        1158: voterSvg, // Four Year Average Voter Participation Rate 
        1165: libraryAccessSvg, // Library Access
        1160: trailsSvg, // Pedestrian and Bike Trails
        1149: healthyFoodSvg, // Food Access
        1129: houseSvg, // Median Home Value
        1128: healthInsuranceSvg, // Health Uninsured Rate
        1150: fatalSvg, // Fatal Service Injury Crashes
        1146: lifeExpectancySvg, // Percent Low Life Expectancy
        1181: costBurdenSvg, // Cost-Burdened Households
        1159: selfRatedSvg, // Self Rated Health
        1151: walkabilityindexSvg, // Walkability Index
        1167: qualityjobsSvg, // Quality Jobs Index
        1140: unemploymentSvg, // Unemployment Rate
        1126: hhincomeSvg, // Median Household Income
        1125: homeOwnershipSvg, // Home Ownership Rate
        1138: nonautoSvg, // Non auto Commuters
        1139: povSvg, // Poverty Rate
        1127: educationAttainSvg, // Educational Attainment
        1163: hsgradSvg, // Four Year HS Graduation Rate
        1162: studentTestSvg, // Average Student Test Rate
        1161: studentMobilitySvg, // Average Student Mobility Rate
        1164: kindergartenSvg, // Kindergarten Readiness
        1141: trafficSvg, // Heavy Traffic Roadways
        1152: treesSvg, // Urban Tree Canopy
        1142: dieselSvg, // Diesel Emissions
        1144: pmSvg, // PM 2.5 Concentration
        1145: toxicReleaseSvg, // Toxic Releases from Facilities
        1143: ozoneSvg, // Ozone Concentration
    },
    
};

// #endregion



// getMetricGroupIds - get the metric id values for a specific grouping 
export const getMetricGroupIds = (orgId: number | null, name: string) => {
    if (!orgId || !organizationMetrics[orgId]) return [];
    
    const group = organizationMetrics[orgId].find((x: { name: string }) => x.name === name);
    return group ? group.ids : [];
};

// Store our organization Id where we can access it later
// export let orgId: number = 5000;
// console.log('current orgId:', orgId);
// export const setOrgId = (id: number) => {
//     orgId = id;
// }

// Store our overlapping county fips codes for BLS and TRS data queries
export var countyId: string[] = [];
export const setCountyIds = (id: string[]) => {
    countyId = id;
}
export const getCountyIds = () => {
    return countyId;
}

// Store our bounding box so we can access it later
export let boundingBox: BoundingBox | null = null;
export const setBoundingBox = (bb: BoundingBox) => {
    boundingBox = bb;
}

// Store our excludeIds so we can access them later
export let excludeIds: string[] | null = null;
export const setExcludeIds = (ids: string[]) => {
    excludeIds = ids;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgMap = (orgId: number | null, id: number) => {
    if (!orgId || !svgMap[orgId]) return "";
    
    return svgMap[orgId][id] || "";
};

// getMetricGroupOrderIds - get the ordering for a metric group
export const getMetricGroupOrderIds = (orgId: number | null, name: string) => {
    if (!orgId || !organizationMetrics[orgId]) return [];

    const group = organizationMetrics[orgId].find((x: { name: string }) => x.name === name);
    return group ? group.order : [];
};

// getMetricGroupChartId - get a metric id given the group and chart key
export const getMetricGroupChartId = (orgId: number | null, group: string, key: string) => {
    if (!orgId || !organizationMetrics[orgId]) return -1;

    const g = organizationMetrics[orgId].find((x: { name: string }) => x.name === group);
    if (!g || !g.charts) return -1;

    const chart = g.charts.find((x: { name: string }) => x.name === key);
    return chart ? chart.id : -1;
};

export const getDonutChartMetricIds = (orgId: number | null, category: string) => {
    if (orgId === null || !organizationMetrics[orgId]) return [];
    const group = organizationMetrics[orgId].find((x) => x.name === category);
    return group?.donutCharts ?? [];
};

export const getRaceEthnicityMetricIds = (orgId: number | null, category: string) => {
    if (orgId === null || !organizationMetrics[orgId]) return [];
    const group = organizationMetrics[orgId].find((x) => x.name === category);
    return group?.raceEthnicity ?? [];
};

export const categorizeData = (orgId: number | null, indicators: DisaggregatedMetric[]) => {
    if (!orgId) return {}; // Handle case when orgId is null


    const categories: { [key: string]: number[] } = {
        Livability: getMetricGroupIds(orgId, "Livability"),
        Education: getMetricGroupIds(orgId, "Education"),
        Economy: getMetricGroupIds(orgId, "Economy"), 
        Environment: getMetricGroupIds(orgId, "Environment"),
        Accessibility: getMetricGroupIds(orgId, "Accessibility"),
        Demographics: getMetricGroupIds(orgId, "Demographics"),
    };

    // Initialize the categorizedData object dynamically with empty arrays for each category
    const categorizedData: Record<string, Metric[]> = Object.keys(categories).reduce((acc, category) => {
        acc[category] = [];
        return acc;
    }, {} as Record<string, Metric[]>);

    // Categorize the indicators dynamically
    indicators.forEach((item) => {
        Object.keys(categories).forEach((category) => {
            if (categories[category].includes(item.id)) {
                categorizedData[category].push(item);
            }
        });
    });

    return categorizedData;
};

export const fetchMetricCategories = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetriccategories?orgId=${orgId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadata = async (id: number) => {
    if (!id) {
        console.log('No id provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetricmetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadataByOrg = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetadatabyorg`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orgId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetch PercentileDist - get percentile distribution information by org and category
export const fetchPercentileDist = async (orgId: number, category: string) => {
    if (!orgId || !category) {
        console.log('No orgId or category provided to fetch metric percentile distributions');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentiledist?orgId=${orgId}&category=${category}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetchDistributionData - get distribution data by metric id and selected area
export const fetchDistributionData = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getdistributiondata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchIndicatorBinCount - get indicator data and bin count by metric id and selected area
export const fetchIndicatorBinCount = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getindicatorbincounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchStateData - retreive state data for a selected metric using a prefix state code
export const fetchStateData = async (metricId: number, geoPrefix: string) => {
    if (!metricId || !geoPrefix) {
        console.log('No metricId or geoDetails provided to fetch metric state data');
        return;
    }

    console.log('geoprefix:', geoPrefix);

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoPrefix }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric state data:', error);
    }
};

// fetchNationalData - retreive national data for a selected metric
export const fetchNationalData = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch national metric data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching national metric data:', error);
    }
};

export const calculateGeoPrefix = (geoDetails: GeoDetails[]): string => {
    // Flatten the geoIds array
    const geoIds = geoDetails.flatMap(geo => geo.ids);

    // Helper function to get the first two digits of a geoId
    const getGeoPrefix = (geoId: string): string => geoId.substring(0, 2);

    // Count occurrences of each prefix
    const prefixCount: Record<string, number> = {};
    geoIds.forEach(geoId => {
        const prefix = getGeoPrefix(geoId);
        prefixCount[prefix] = (prefixCount[prefix] || 0) + 1;
    });

    // Find the prefix with the highest count
    return Object.entries(prefixCount).reduce((prev, curr) => 
        curr[1] > prev[1] ? curr : prev, ['', 0]
    )[0];
};


// getMissingMetrics - utility function to check for missing metrics on a given dashboard panel
export const getMissingMetrics = (
    tab: string,
    categorizedData: Metric[],
    indicators: DisaggregatedMetric[] | null
  ): string => {
    if (!indicators) return '';
  
    const missingMetrics = indicators?.filter(metric => 
        metric.category?.toLowerCase() === tab.toLowerCase() && 
        !categorizedData.some(data => data.id === metric.id)
    ) || [];    
  
    return missingMetrics.map(metric => metric.name).join(", ");
};

// Helper function to get and sort metrics by category
export const getSortedMetrics = (orgId: number | null, category: string, categorizedData: CategorizedData) => {
    if (!orgId) return []; // Handle case when orgId is null

    const orders = getMetricGroupOrderIds(orgId, category);

    return orders.map((order: number[]) => 
        categorizedData[category]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};

// Helper function to get and sort metrics by category - Used in PDF metrics display
export const getSortedMetricsPDF = (
    orgId: number | null,
    category: string,
    categorizedData: { category: string; metrics: DisaggregatedMetric[] }[]
): DisaggregatedMetric[] => {
    if (!orgId) return []; // Handle case when orgId is null

    const metrics = categorizedData.find(data => data.category === category)?.metrics || [];
    const orders = getMetricGroupOrderIds(orgId, category);

    return orders.flatMap((order: number[]) =>
        metrics
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};
  
// Helper function to get the index metric data
export const getIndexMetricData = (
    category: string, 
    metadata: MetricMetadata[] | null, 
    disaggregatedData: DisaggregatedMetric[]
): { indexMetricId: number; indexMetricData: DisaggregatedMetric | null } => {
    
    const indexMetricId = metadata?.find(
        (metric) => 
            metric.metric_source_type === "index" && 
            metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;

    const indexMetricData = disaggregatedData.find(metric => metric.id === indexMetricId) || null;

    return { indexMetricId, indexMetricData };
};

// Helper function to get the index metric data - Formatted for PDF (MetricModal) use.
export const getIndexMetricDataPDF = (category: string, metadata: MetricMetadata[] | null, disaggregatedData: DisaggregatedMetric[]): DisaggregatedMetric | null => {
    const indexMetricId = metadata?.find(
        (metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;
    return disaggregatedData.find(metric => metric.id === Number(indexMetricId)) || null;
};

export const fetchCountyFips = async (orgId: number | null): Promise<GeoTag | null> => {
    try {
        const response = await fetch("https://retoolapi.dev/kimBN3/locations");
        const locations: any[] = await response.json();
        const matchingLocation = locations.find(location => Number(location.orgId) === orgId);
        
        return matchingLocation 
        ? { type: "county", value: matchingLocation.countyFips } 
        : null;
    } catch (error) {
        console.error("Error fetching county FIPS:", error);
        return null;
    }
};
